<fgb-banner [title]="'savings.page.banner' | translate" class="d-none d-lg-block"></fgb-banner>

<fgb-endurance-zone></fgb-endurance-zone>
